<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="store"
      label-position="left"
      label-width="140px"
      class="form"
      style="width: 620px; margin-left:50px;"
    >
      <el-form-item label="名称" prop="store_name">
        <el-input v-model="store.store_name" />
      </el-form-item>

      <v-image-upload
        v-model="store.cover"
        label="封面"
        prefix="store"
        ratio="1:1"
        propName="cover"
      />

      <el-form-item label="地址" prop="address">
        <el-input v-model="store.address" placeholder="请输入门店的地址"/>
      </el-form-item>

      <el-form-item label="腾讯地图坐标" prop="coordinate">
        <el-input
          v-model="store.coordinate"
          placeholder="请输入格式为 LAT,LNG 的腾讯地图坐标，例如：39.90522,116.460622"
        />
        <a class="primary-color" href="https://lbs.qq.com/getPoint/" target="_blank">点此搜索坐标</a>
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input v-model="store.phone" placeholder="请输入门店的手机号"/>
      </el-form-item>

      <el-form-item label="微信号" prop="we_chat_number">
        <el-input v-model="store.we_chat_number" placeholder="请输入门店的微信号"/>
      </el-form-item>

      <v-image-upload
        v-model="store.we_chat_cover"
        label="微信二维码"
        prefix="store"
        ratio="1:1"
        propName="we_chat_cover"
      />

      <el-form-item label="营业时间" prop="business_hours">
        <el-input v-model="store.business_hours"/>
      </el-form-item>

      <el-form-item label="课表图片高亮颜色" prop="schedule_color">
        <el-input
          v-model="store.schedule_color"
          minlength="5"
          maxlength="11"
          placeholder="请输入格式为 R,G,B 的课表图片高亮颜色，例如黑色：0,0,0"
        >
        </el-input>
      </el-form-item>

      <el-form-item label="每月成本">
        <el-input
          v-model="store.cost"
          min="0"
          type="number"
        >
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="每月房租">
        <el-input
          v-model="store.rent"
          min="0"
          type="number"
        >
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="企业微信标签 ID">
        <el-input v-model="store.we_chat_tag_id" min="0" type="number" />
      </el-form-item>
      <el-form-item label="收入分成比例">
        <el-input
          v-model="store.revenue_sharing"
          min="0"
          max="100"
          type="number"
          @input="handleRevenueSharingChange"
        >
          <template v-slot:append>%</template>
        </el-input>
      </el-form-item>

      <el-form-item label="是否启用阶梯式分成">
        <el-switch v-model="store.is_ladder_commission" :active-value="1" :inactive-value="0"/>
        <el-alert
          title="总部对门店的默认分成方式为：总收入 × 分成比例，最多不超过净利润（总收入 - 总支出）的 40 %；开启后则根据总收入大小按阶梯式分成，最低分成为 1000 元，最多不超过毛利润（总收入 - 房租 - 老师工资 - 员工工资）的 20 %"
          type="info"
          show-icon
          :closable="false"
          class="alert-box"
        />
        <el-alert
          title="阶梯式分成比例：
收入 0 - 10 万，4 %；
收入 10 - 15 万，5 %；
收入 15 - 20 万，6 %；
收入 20 - 30 万，7 %；
收入 30 万以上，8 %"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="前台提成比例">
        <el-input
          v-model="store.receptionist_percentage"
          min="0"
          max="100"
          type="number"
          @input="handleReceptionistPercentage"
        >
          <template v-slot:append>%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="未完成任务底薪比例">
        <el-input
          v-model="store.unfinished_rate"
          min="0"
          max="100"
          type="number"
          @input="handleUnfinishedRate"
        >
          <template v-slot:append>%</template>
        </el-input>
      </el-form-item>

      <el-form-item label="业绩任务">
        <el-input
          v-model="store.task_income"
          min="0"
          type="number"
        >
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="是否开启业绩任务">
        <el-switch v-model="store.task_enabled" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item label="课卡是否全国通用">
        <el-switch v-model="store.is_generic" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item label="是否在小程序显示">
        <el-switch v-model="store.is_private" :active-value="0" :inactive-value="1" />
      </el-form-item>
      <el-form-item label="小程序课表默认分类">
        <el-radio v-for="courseTab in courseTabs" :key="courseTab" v-model="store.course_tab" :label="courseTab">{{ courseTab }}</el-radio>
      </el-form-item>

      <el-form-item label="小程序客服号">
        <v-select-customer
          v-model="store.open_kfid"
          :clearable="true"
          placeholder="请选择小程序客服号"
        />
      </el-form-item>

      <el-form-item label="是否启用阶梯式薪资">
        <el-switch v-model="store.is_ladder_salary" :active-value="1" :inactive-value="0" />
      </el-form-item>

      <div v-show="store.is_ladder_salary" v-for="cardType in cardTypes" :key="cardType.id" class="table-box">
        <h3 class="table-title">{{ cardType.card_type_name }}薪资设置</h3>
        <el-table
          :data="cardType.salaries"
          class="income-table"
          border
          fit
          highlight-current-row
        >
          <el-table-column label="最低人数" align="center">
            <template v-slot="{ $index, row}">
              <div class="flex-align-center">
                <v-input-number
                  :is-plain="true"
                  v-model="row.min_number"
                  :min="getMinNumber(cardType.salaries, $index)"
                  :max="99"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最多人数" align="center">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-number :is-plain="true" v-model="row.max_number" :min="row.min_number" :max="99"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="薪资" align="center">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money :is-plain="true" v-model="row.salary"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template v-slot="{ $index, row }">
              <el-popover placement="top" v-model="row.showTip">
                <p>确认要删除吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="row.showTip = false">取消</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleDelete($index, cardType.salaries)"
                  >
                    确认
                  </el-button>
                </div>
                <template slot="reference">
                  <el-button class="edit-button" size="mini" type="danger">删除</el-button>
                </template>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="add-button" type="primary" @click="addSalaries(cardType)">新增一项</el-button>
      </div>

      <div class="submit-button-box">
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.storeList.back">取消</el-button>
      </div>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from "@/router/config";
import { getStoreCardTypes, store } from '@/api/store';
import { multipliedBy } from '@/utils/number';
import { courseTabs } from '@/enums/courseTabs';

export default {
  name: RouteConfig.storeAdd.name,
  data: () => ({
    RouteConfig,
    courseTabs,
    isSaving: false,
    cardTypes: [],
    store: {
      store_name: '',
      address: '',
      coordinate: '',
      phone: '',
      we_chat_number: '',
      we_chat_cover: '',
      business_hours: '11:00-21:00',
      schedule_color: '0,0,0',
      cost: '',
      rent: '',
      revenue_sharing: 0,
      receptionist_percentage: '',
      unfinished_rate: '',
      cover: '',
      we_chat_tag_id: '',
      task_income: '',
      is_generic: 0,
      task_enabled: 0,
      is_private: 0,
      is_ladder_salary: 0,
      course_tab: courseTabs.adult,
      is_ladder_commission: 0,
      open_kfid: '',
    },
    rules: {
      store_name: [{ required: true, message: '请输入门店名称', trigger: 'change' }],
      cover: [{ required: true, message: '请上传门店封面', trigger: 'change' }],
      address: [{ required: true, message: '请输入门店地址', trigger: 'change' }],
      coordinate: [{ required: true, message: '请输入门店的腾讯地图坐标', trigger: 'change' }],
      phone: [{ required: true, message: '请输入门店的手机号', trigger: 'change' }],
      we_chat_number: [{ required: true, message: '请输入门店的微信号', trigger: 'change' }],
      we_chat_cover: [{ required: true, message: '请上传门店微信二维码', trigger: 'change' }],
      business_hours: [{ required: true, message: '请输入门店的营业时间', trigger: 'change' }],
      schedule_color: [{ required: true, message: '请输入格式为 R,G,B 的课表图片高亮颜色，例如黑色：0,0,0', trigger: 'change' }],
      course_tab: [{ required: true, message: '请选择小程序课表默认分类', trigger: 'change' }],
    },
  }),
  beforeMount() {
    this.getCardTypes();
  },
  methods: {
    addSalaries({ id, salaries }) {
      const index = salaries.length;
      const minNumber = index === 0 ? 1 : this.getMinNumber(salaries, index);

      salaries.push({
        card_type_id: id,
        min_number: minNumber,
        max_number: minNumber + 1,
        salary: 0,
      });
    },
    handleDelete(index, rows) {
      rows.splice(index, 1);
    },
    getMinNumber(salaries, index) {
      let minNumber = index === 0 ? 1 : salaries[index - 1].max_number + 1;
      if (minNumber > 99) minNumber = 1;

      return minNumber;
    },

    async getCardTypes() {
      const { isError, data } = await getStoreCardTypes();
      if (isError) return;

      data.forEach(item => {
        item.salaries = [];
      });

      this.cardTypes = data;
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;

        const postData = { ...this.store };
        postData.cost = multipliedBy(postData.cost, 100);
        postData.rent = multipliedBy(postData.rent, 100);
        postData.task_income = multipliedBy(postData.task_income, 100);
        postData.revenue_sharing = multipliedBy(postData.revenue_sharing, 100);

        const [ latitude_gcj, longitude_gcj ] = postData.coordinate.split(',');
        postData.latitude_gcj = latitude_gcj;
        postData.longitude_gcj = longitude_gcj;

        if (postData.is_ladder_salary) {
          postData.ladder_salaries = [];
          this.cardTypes.forEach(cardType => {
            cardType.salaries.forEach(item => {
              postData.ladder_salaries.push({
                card_type_id: item.card_type_id,
                min_number: item.min_number,
                max_number: item.max_number,
                salary: multipliedBy(item.salary, 100),
              });
            });
          });
        }

        const { isError } = await store(postData);

        this.isSaving = false;

        if (!isError) RouteConfig.storeList.push();
      });
    },
    handleRevenueSharingChange(value) {
      if (value < 0) {
        this.store.revenue_sharing = 0;
      } else if (value > 100) {
        this.store.revenue_sharing = 100;
      }
    },
    handleReceptionistPercentage(value) {
      if (value < 0) {
        this.store.receptionist_percentage = 0;
      } else if (value > 100) {
        this.store.receptionist_percentage = 100;
      }
    },
    handleUnfinishedRate(value) {
      if (value < 0) {
        this.store.unfinished_rate = 0;
      } else if (value > 100) {
        this.store.unfinished_rate = 100;
      }
    },
  },
};
</script>

<style src="./add.css" lang="css" scoped/>
